import { useEffect } from 'react';

const ChatbaseWidget = (props) => {
    const chatbotId = props.context.configuration?.chatbotId;

    useEffect(() => {
        if (!chatbotId) return;

        // Add Chatbase configuration
        window.embeddedChatbotConfig = {
            chatbotId: chatbotId,
            domain: 'www.chatbase.co',
        };

        // Create and append script
        const script = document.createElement('script');
        script.src = 'https://www.chatbase.co/embed.min.js';
        script.setAttribute('chatbotId', chatbotId);
        script.setAttribute('domain', 'www.chatbase.co');
        script.defer = true;
        document.body.appendChild(script);

        return () => {
            // Cleanup on unmount
            document.body.removeChild(script);
            delete window.embeddedChatbotConfig;
        };
    }, [chatbotId]);

    return null; // This component doesn't render anything visible
};

export default ChatbaseWidget;
